import * as Application from 'expo-application';
import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { v5 as uuidv5 } from 'uuid';
import { v4 as uuidv4 } from 'uuid';

let installationId;
const UUID_NAMESPACE = '29cc8a0d-747c-5f85-9ff9-f2f16636d963'; // uuidv5(0, "expo")

export default async function getInstallationIdAsync() {
  if (installationId) {
    return installationId;
  }

  let identifierForVendor = null;
  switch (Platform.OS) {
    case 'ios':
      identifierForVendor = await Application.getIosIdForVendorAsync();
      break;
    case 'android':
      identifierForVendor = Application.androidId;
      break;
    case 'web':
    default:
      break;
  }

  const bundleIdentifier = Application.applicationId;
  if (identifierForVendor) {
    installationId = uuidv5(`${bundleIdentifier}-${identifierForVendor}`, UUID_NAMESPACE);
  } else {
    installationId = await AsyncStorage.getItem('installationId');
    if (!installationId) {
      installationId = uuidv4();
      await AsyncStorage.setItem('installationId', installationId);
    }
  }
  return installationId;
}
